module.exports = __webpack_public_path__ + "img/__delete_danger.e5615eae.svg";